"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegularTwister = void 0;
const react_1 = __importStar(require("react"));
const __1 = require("../");
const themed_text_1 = require("../../themed-text");
const variation_context_container_1 = require("../../variation-context-container");
const styles_1 = require("./styles");
const TwisterButton_1 = require("./TwisterButton");
const RegularTwister = ({ displayString, hoverState, dimensionKeyIndex, dimensionValues, variationState, variationMap, handleOnClick, setHoverState, seeAvailableOptionsCopy }) => {
    const { setCurrentVariation } = (0, variation_context_container_1.useVariationContext)();
    (0, react_1.useEffect)(() => {
        setCurrentVariation(variationState);
    }, [variationState]);
    const handleHoverState = (values) => {
        if (values) {
            const [dimensionKeyIndex, dimensionValueIndex] = values;
            const newState = [...variationState];
            newState[dimensionKeyIndex] = dimensionValueIndex;
            const asin = (0, __1.getAsinFromVariation)(variationMap, newState) ||
                (0, __1.getAsinFromClick)(variationMap, dimensionKeyIndex, dimensionValueIndex) ||
                '';
            const newValues = (0, __1.getVariationValuesFromAsin)(variationMap, asin);
            setCurrentVariation(newValues);
        }
        else {
            setCurrentVariation(variationState);
        }
        setHoverState(values);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.LabelContainer, null,
            react_1.default.createElement(themed_text_1.ThemedSpan, { color: 'secondary' },
                displayString,
                ": "),
            react_1.default.createElement(themed_text_1.ThemedSpan, { bold: true }, (hoverState === null || hoverState === void 0 ? void 0 : hoverState[0]) === dimensionKeyIndex
                ? dimensionValues[dimensionKeyIndex][hoverState[1]]
                : dimensionValues[dimensionKeyIndex][variationState[dimensionKeyIndex]])),
        react_1.default.createElement(styles_1.ButtonContainer, null, dimensionValues[dimensionKeyIndex].length > 1
            ? dimensionValues[dimensionKeyIndex].map((e, dimensionValueIndex) => {
                const variationValues = [...variationState];
                variationValues[dimensionKeyIndex] = dimensionValueIndex;
                const asin = (0, __1.getAsinFromVariation)(variationMap, variationValues);
                return (react_1.default.createElement(TwisterButton_1.TwisterButton, { key: e, dimensionValueIndex: dimensionValueIndex, dimensionKeyIndex: dimensionKeyIndex, asin: asin, variationState: variationState, e: e, handleOnClick: handleOnClick, setHoverState: handleHoverState, seeAvailableOptionsCopy: seeAvailableOptionsCopy }));
            })
            : null)));
};
exports.RegularTwister = RegularTwister;
